import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FunctionsService } from "../../../services/functions.service";
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';

@Component({
    selector: 'app-view-notification',
    templateUrl: './view-notification.component.html',
    styleUrls: ['./view-notification.component.css'],
})

export class ViewNotificationComponent implements OnInit {

    displayedColumns: string[] = ['fullName', 'email', 'phoneNumber', 'role'];
    dataSource:any = new MatTableDataSource<any>();
    @ViewChild('Sort', {static: true}) sort: MatSort;
    @ViewChild('Paginator', {static: true}) paginator: MatPaginator;
    

    constructor(
        private apiService: ApiService,
        public functionsService:FunctionsService,
        public translate: TranslateService,
        public spinner: NgxSpinnerService,
        private route: ActivatedRoute,
        private router: Router){}


        _notiToView: any = {
            approvedBy: 0,
            approvedDate: "",
            approverFirstName: "",
            approverLastName: "",
            created: "",
            createdBy: 0,
            createdFirstName: "",
            createdLastName: "",
            deviceCount: 0,
            emailCount: 0,
            emailNotification: false,
            id: 0,
            message: "",
            modified: false,
            modifiedBy: 0,
            modifiedFirstName: "",
            modifiedLastName: "",
            organizationId: 0,
            pushNotification: false,
            rejectReason: "",
            scheduled: false,
            sentBy: 0,
            sentDate: "",
            sentFirstName: "",
            sentLastName: "",
            sms: false,
            smsCount: 0,
            status: 0,
            tagId: "",
            tagName: "",
            title: "",
            voiceCall: false,
            voiceCallCount: 0
        };
        filter = "";
        pageIndex = 0;
        pageSize = 5;
        totalLength = 0;
        notificationId = this.route.snapshot.paramMap.get('id');
        roles = ["User","Admin","SecurityAgent","Supervisor"];
        sendVia: string;

    ngOnInit(){

        this.translate.onLangChange.subscribe(() => {
            if(this._notiToView)
                this.getSendVia(this._notiToView)
        })

        this.getNotification(this.notificationId);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }

    getNotification(id) {
        this.spinner.show();
        this.apiService.getNotification(id).subscribe(
            data => {
                this.getSendVia(data);
                this._notiToView = data;
                this.fetchNotificationUsers(id);
                this.spinner.hide();
            },
            error => {
                this.spinner.hide();
                this.functionsService.errorHandler(error["status"]);
            }
        );
    }

    fetchNotificationUsers(id) {
        this.spinner.show(); 
        this.apiService.getNotificationUsers(id, this.filter).subscribe(resp => {
            this.dataSource.data = resp;
            this.dataSource.data.forEach(element => {
                if(element.role == 'Owner'){
                element.email = '-';
                element.phoneNumber = '-';
                }
            });
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
            if(document.getElementsByClassName("mat-paginator-page-size-label")[0]){
                document.getElementsByClassName("mat-paginator-page-size-label")[0].innerHTML = this.translate.instant("paginator.items_per_page");
            }
            this.spinner.hide();
        }, error => {
            this.functionsService.errorHandler(error["status"]);
            this.spinner.hide();
        });
    }

    applyFilter() {
        if((<HTMLInputElement>document.getElementById('filter')).value !=""){
            this.filter = (<HTMLInputElement>document.getElementById('filter')).value;
            this.filter = this.filter.trim().toLowerCase();
        }
        this.pageIndex = 0;
        this.fetchNotificationUsers(this.notificationId);
    }

    clearFilter(){
        this.filter = "";
        if((<HTMLInputElement>document.getElementById('filter'))){
            (<HTMLInputElement>document.getElementById('filter')).value = "";
        }
        
        this.fetchNotificationUsers(this.notificationId);
    }

    getSendVia(data){
        this.sendVia = "";
        let selectedVia = new Map();
        selectedVia.set(`${this.translate.instant("notification.send_via_app")}, `, data["pushNotification"]);
        selectedVia.set(`${this.translate.instant("notification.send_via_email")}, `, data["emailNotification"]);
        selectedVia.set(`${this.translate.instant("notification.send_via_sms")}, `, data["sms"]);
        selectedVia.set(`${this.translate.instant("notification.send_via_voice")}, `, data["voiceCall"]);

        for(let [key, value] of selectedVia)
            {
                if(value)
                {
                    this.sendVia += key;
                }
            }
        
        this.sendVia = this.sendVia.substring(0, this.sendVia.length-2);
    }
}